import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from "moment";
import Table from '../common/Table';
import SearchForm from './SearchForm';

export default class TicketRequests extends Component {
    constructor(props) {
        super(props)
        this.state = {
            TicketRequests: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            from: '',
            to: '',
            total: '',
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    /**
     * Prepare render jobs
     */
    prepareRender(response) {
        response.map((Ticket) => {
            var ary = [];
            var working_time = '';
            if (Ticket.preferred_date1 != null) {
                ary.push("①" + moment(Ticket.preferred_date1).format('Y年MM月DD日 HH:mm'));
            }
            if (Ticket.preferred_date2 != null) {
                ary.push("②" + moment(Ticket.preferred_date2).format('Y年MM月DD日 HH:mm'));
            }
            if (Ticket.preferred_date3 != null) {
                ary.push("③" + moment(Ticket.preferred_date3).format('Y年MM月DD日 HH:mm'));
            }
            Ticket.preferred_date = ary.join('\n');

            if (Ticket.working_hours > 0) {
                working_time = Ticket.working_hours + '時間';
            }
            if (Ticket.working_minute > 0) {
                working_time += Ticket.working_minute + '分';
            }
            Ticket.working_time = working_time;

        })
    }

    /**
     * Init data and form job or list jobs
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
        }

        //always get list data
        axios.post('/api/ticket_requests/search', keySearch_arr).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                TicketRequests: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }

    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/ticket_requests/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                TicketRequests: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }

    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/ticket_requests/search', key).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                TicketRequests: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }

    /**
     * Edit TicketRequests
     * TicketRequests: Object Client
     */
    handleEdit(TicketRequests) {
        this.props.history.push('/ticketrequests/edit/' + TicketRequests.id);
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }



    render() {
        const option = {
            "1":{text:'支払い待ち',classHTML:'text-yellow'},
            "2":{text:'予定',classHTML:'text-teal'},
            "3":{text:' 評価待ち',classHTML:'text-yellow'},
            "4":{text:'評価完了',classHTML:'text-gray'},
            "5":{text:'見送り',classHTML:'text-pink'},
            "6":{text:'未決済キャンセル',classHTML:'text-pink'},
            "7":{text:'依頼者キャンセル',classHTML:'text-pink'},
            "8":{text:'ワーカーキャンセル',classHTML:'text-pink'},
            "9":{text:'運営キャンセル',classHTML:'text-pink'},
            "0":{text:'承認待ち',classHTML:'text-yellow'},
            null:{text:'承認待ち',classHTML:'text-yellow'}
        };
        const columns = [
            {name: 'id', title: 'No.', isSort: 1, type: 'text'},
            {name: 'helper_ticket_id', title: 'チケットID', isSort: 1, type: 'text'},
            {name: 'request_user_name', title: '依頼者名', isSort: 1, type: 'text', isSearch:true},
            {name: 'helper_user_name', title: '助っ人名', isSort: 1, type: 'text', isSearch:true},
            {name: 'categories_name', title: 'カテゴリ名', isSort: 1, type: 'text_break_line', isSearch:true},
            {name: 'preferred_date', title: '希望日時', isSort: 0, type: 'text_break_line'},
            {name: 'confirm_date', title: '開始日時', isSort: 1, type: 'date_time', isSearch:true},
            {name: 'status', title: 'ステータス', isSort: 1, type: 'status_option', option:option},
            {name: 'reward_amount', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero', prefix:'¥'},
            {name: 'amount_system_fee', title: 'システム利用料', isSort: 0, type: 'convert_to_number_with_zero', prefix:'¥'},
            {name: 'amount_system_tax', title: '消費税', isSort: 0, type: 'convert_to_number_with_zero', prefix:'¥'},
            {name: 'working_time', title: '所要時間', isSort: 0, type: 'text_break_line'},
            {name: 'evaluation_from_client', title: '依頼者からの評価', isSort: 0, type: 'text'},
            {name: 'evaluation_from_worker', title: '助っ人からの評価', isSort: 0, type: 'text'},
        ]
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">チケット申込み一覧</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">チケット申込み一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_order" aria-expanded="false" aria-controls="search_order">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table onSearch={this.handleSearch} onSort={this.handleSort} onEdit={this.handleEdit} header={columns} data={this.state.TicketRequests}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} from={this.state.from} to={this.state.to} total={this.state.total} />
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        );
    }

}
